import { useQuery } from "@tanstack/react-query";
import { roomApi } from "../../services/endpoints";
import { unwrapList } from "../../services/response";
import type { Raeume } from "../../types/entities";

export const roomsQueryKey = ["rooms"];

/**
 * All rooms (Räume). Replaces the room fetch inside the old getData() bundle +
 * AppState.raumeSelection. Refreshed by invalidating ['rooms'] after a room
 * create/update.
 */
export const useRooms = (enabled = true) =>
  useQuery({
    queryKey: roomsQueryKey,
    queryFn: async (): Promise<Raeume[]> => {
      const res = await roomApi.getAll();
      return unwrapList<Raeume>(res);
    },
    enabled,
  });
